import { render, staticRenderFns } from "./FeederFirmware.vue?vue&type=template&id=3b87ff96&scoped=true"
import script from "./FeederFirmware.vue?vue&type=script&lang=js"
export * from "./FeederFirmware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87ff96",
  null
  
)

export default component.exports